export default "__VITE_ASSET__Cm_LlAR0__"